module.exports = "<div class=\"col-12 np\">\n  <div class=\"col-12 np\" [ngClass]=\"data.active ? 'on' : 'off'\">\n    {{time}}\n  </div>\n</div>\n"